// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidPackageDetailsStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BidPackageDetailsStepQuery = { __typename?: 'Query', bidScopeSourceDetail: Array<{ __typename?: 'BidScopeSourceDetail', code: Types.BidScopeSource, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }> };

export type BidPackageDetailsStep_BidScopeSourceFragment = { __typename?: 'BidScopeSourceDetail', code: Types.BidScopeSource, name: string };

export const BidPackageDetailsStep_BidScopeSourceFragmentDoc = gql`
    fragment BidPackageDetailsStep_BidScopeSource on BidScopeSourceDetail {
  code
  name
}
    `;
export const BidPackageDetailsStepDocument = gql`
    query BidPackageDetailsStep {
  bidScopeSourceDetail {
    ...BidPackageDetailsStep_BidScopeSource
  }
  markets {
    ...Named
  }
  costCodes(filter: {version: 2}) {
    ...Named
  }
}
    ${BidPackageDetailsStep_BidScopeSourceFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useBidPackageDetailsStepQuery__
 *
 * To run a query within a React component, call `useBidPackageDetailsStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidPackageDetailsStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidPackageDetailsStepQuery({
 *   variables: {
 *   },
 * });
 */
export function useBidPackageDetailsStepQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BidPackageDetailsStepQuery, BidPackageDetailsStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidPackageDetailsStepQuery, BidPackageDetailsStepQueryVariables>(BidPackageDetailsStepDocument, options);
      }
export function useBidPackageDetailsStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidPackageDetailsStepQuery, BidPackageDetailsStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidPackageDetailsStepQuery, BidPackageDetailsStepQueryVariables>(BidPackageDetailsStepDocument, options);
        }
// @ts-ignore
export function useBidPackageDetailsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidPackageDetailsStepQuery, BidPackageDetailsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackageDetailsStepQuery, BidPackageDetailsStepQueryVariables>;
export function useBidPackageDetailsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackageDetailsStepQuery, BidPackageDetailsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackageDetailsStepQuery | undefined, BidPackageDetailsStepQueryVariables>;
export function useBidPackageDetailsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackageDetailsStepQuery, BidPackageDetailsStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidPackageDetailsStepQuery, BidPackageDetailsStepQueryVariables>(BidPackageDetailsStepDocument, options);
        }
export type BidPackageDetailsStepQueryHookResult = ReturnType<typeof useBidPackageDetailsStepQuery>;
export type BidPackageDetailsStepLazyQueryHookResult = ReturnType<typeof useBidPackageDetailsStepLazyQuery>;
export type BidPackageDetailsStepSuspenseQueryHookResult = ReturnType<typeof useBidPackageDetailsStepSuspenseQuery>;
export type BidPackageDetailsStepQueryResult = ApolloReactCommon.QueryResult<BidPackageDetailsStepQuery, BidPackageDetailsStepQueryVariables>;